import { render, staticRenderFns } from "./ReplacementsView.vue?vue&type=template&id=06ce5fc8"
import script from "./ReplacementsView.vue?vue&type=script&lang=js"
export * from "./ReplacementsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports